var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-container"},[_c('iframe',{staticClass:"kpayment-m-top-hide",staticStyle:{"width":"100%","z-index":"1090","border":"unset"},attrs:{"_kpayment":"","src":'/Payment-Gateway/embeddedKBank.html?order_id=' + _vm.receiptObjectId + '&amount=' + _vm.docTotal + '&name=' + _vm.shopName + '&paymentUrl=' + _vm.silomPaymentUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }